/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function (a, b, c) {
    var d = window.matchMedia;
    "undefined" != typeof module && module.exports ? module.exports = c(d) : "function" == typeof define && define.amd ? define(function () {
        return b[a] = c(d)
    }) : b[a] = c(d)
}("enquire", this, function (a) {
    "use strict";

    function b(a, b) {
        var c, d = 0, e = a.length;
        for (d; e > d && (c = b(a[d], d), c !== !1); d++) ;
    }

    function c(a) {
        return "[object Array]" === Object.prototype.toString.apply(a)
    }

    function d(a) {
        return "function" == typeof a
    }

    function e(a) {
        this.options = a, !a.deferSetup && this.setup()
    }

    function f(b, c) {
        this.query = b, this.isUnconditional = c, this.handlers = [], this.mql = a(b);
        var d = this;
        this.listener = function (a) {
            d.mql = a, d.assess()
        }, this.mql.addListener(this.listener)
    }

    function g() {
        if (!a) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        this.queries = {}, this.browserIsIncapable = !a("only all").matches
    }

    return e.prototype = {
        setup: function () {
            this.options.setup && this.options.setup(), this.initialised = !0
        }, on: function () {
            !this.initialised && this.setup(), this.options.match && this.options.match()
        }, off: function () {
            this.options.unmatch && this.options.unmatch()
        }, destroy: function () {
            this.options.destroy ? this.options.destroy() : this.off()
        }, equals: function (a) {
            return this.options === a || this.options.match === a
        }
    }, f.prototype = {
        addHandler: function (a) {
            var b = new e(a);
            this.handlers.push(b), this.matches() && b.on()
        }, removeHandler: function (a) {
            var c = this.handlers;
            b(c, function (b, d) {
                return b.equals(a) ? (b.destroy(), !c.splice(d, 1)) : void 0
            })
        }, matches: function () {
            return this.mql.matches || this.isUnconditional
        }, clear: function () {
            b(this.handlers, function (a) {
                a.destroy()
            }), this.mql.removeListener(this.listener), this.handlers.length = 0
        }, assess: function () {
            var a = this.matches() ? "on" : "off";
            b(this.handlers, function (b) {
                b[a]()
            })
        }
    }, g.prototype = {
        register: function (a, e, g) {
            var h = this.queries, i = g && this.browserIsIncapable;
            return h[a] || (h[a] = new f(a, i)), d(e) && (e = {match: e}), c(e) || (e = [e]), b(e, function (b) {
                d(b) && (b = {match: b}), h[a].addHandler(b)
            }), this
        }, unregister: function (a, b) {
            var c = this.queries[a];
            return c && (b ? c.removeHandler(b) : (c.clear(), delete this.queries[a])), this
        }
    }, new g
});

/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function (a) {
    a.fn.equalHeights = function () {
        var b = 0, c = a(this);
        return c.each(function () {
            var c = a(this).innerHeight();
            c > b && (b = c)
        }), c.css("height", b)
    }, a("[data-equal]").each(function () {
        var b = a(this), c = b.data("equal");
        b.find(c).equalHeights()
    })
}(jQuery);

/* Run function after window resize */
var afterResize = (function () {
    var t = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (t[uniqueId]) {
            clearTimeout(t[uniqueId]);
        }
        t[uniqueId] = setTimeout(callback, ms);
    };
})();

window.timber = window.timber || {};

timber.cacheSelectors = function () {
    timber.cache = {
        // General
        $html: $('html'),
        $body: $('body'),
        $breadcrumbs: $('.breadcrumb'),

        // Navigation
        $navigation: $('#accessibleNav'),
        $hasDropdownItem: $('.site-nav--has-dropdown'),
        $menuToggle: $('.menu-toggle'),

        // Home Page
        $slider: $('.flexslider'),

        // Product Page
        $productImageWrap: $('#productPhoto'),
        $productImage: $('#productPhotoImg'),
        $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
        $shareButtons: $('.social-sharing'),

        // Collection Pages
        $collectionFilters: $('#collectionFilters'),
        $toggleFilterBtn: $('#toggleFilters'),

        // Equal height elements
        $featuredBoxes: $('.featured-box'),
        $featuredImages: $('.featured-box--image'),
        $productGridImages: $('.product-grid-image')
    };
};

timber.cacheVariables = function () {
    timber.vars = {
        // Breakpoints (from timber.scss.liquid)
        bpLarge: 769,

        // MediaQueries (from timber.scss.liquid)
        mediaQueryLarge: 'screen and (min-width: 769px)',
        isLargeBp: false,
    }
};

timber.init = function () {
    timber.cacheSelectors();
    timber.cacheVariables();

    timber.cache.$html.removeClass('no-js').addClass('js');
    if ('ontouchstart' in window) {
        timber.cache.$html.removeClass('no-touch').addClass('touch');
    }

    timber.toggleMenu();
    timber.sliders();
    timber.productImageSwitch();
    timber.equalHeights();
    timber.responsiveVideos();
    timber.toggleFilters();
    timber.initBreakpoints();
    timber.loadData();

    // Wait until fonts load to attempt creating 'more' link in nav
    $(window).load(function () {
        timber.responsiveNav();
    });

    
};

timber.initBreakpoints = function () {
    enquire.register(timber.vars.mediaQueryLarge, {
        match: function () {
            timber.vars.isLargeBp = true;
            timber.productImageZoom();
        },
        unmatch: function () {
            timber.vars.isLargeBp = false;
            timber.productImageZoom();
        }
    });
};

timber.accessibleNav = function () {
    var $nav = timber.cache.$navigation,
        $allLinks = $nav.find('a'),
        $topLevel = $nav.children('li').find('a'),
        $parents = $nav.find('.site-nav--has-dropdown'),
        $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
        activeClass = 'nav-hover',
        focusClass = 'nav-focus';

    // Mouseenter
    $parents.on('mouseenter touchstart', function (evt) {
        var el = $(this);

        if (!el.hasClass(activeClass)) {
            evt.preventDefault();
        }

        showDropdown($(this));
    });

    $parents.on('mouseleave', function () {
        hideDropdown($(this));
    });

    $subMenuLinks.on('touchstart', function (evt) {
        // Prevent touchstart on body from firing instead of link
        evt.stopImmediatePropagation();
    });

    $allLinks.focus(function () {
        handleFocus($(this));
    });

    $allLinks.blur(function () {
        removeFocus($topLevel);
    });

    // accessibleNav private methods
    function handleFocus(el) {
        var $subMenu = el.next('ul');
        hasSubMenu = $subMenu.hasClass('site-nav--dropdown') ? true : false,
            isSubItem = $('.site-nav--dropdown').has(el).length,
            $newFocus = null;

        // Add focus class for top level items, or keep menu shown
        if (!isSubItem) {
            removeFocus($topLevel);
            addFocus(el);
        } else {
            $newFocus = el.closest('.site-nav--has-dropdown').find('a');
            addFocus($newFocus);
        }
    }

    function showDropdown(el) {
        el.addClass(activeClass);

        setTimeout(function () {
            timber.cache.$body.on('touchstart', function () {
                hideDropdown(el);
            });
        }, 250);
    }

    function hideDropdown($el) {
        $el.removeClass(activeClass);
        timber.cache.$body.off('touchstart');
    }

    function addFocus($el) {
        $el.addClass(focusClass);
    }

    function removeFocus($el) {
        $el.removeClass(focusClass);
    }
};

timber.responsiveNav = function () {
    $(window).resize(function () {
        afterResize(function () {
            // Replace original nav items and remove more link
            timber.cache.$navigation.append($('#moreMenu--list').html());
            $('#moreMenu').remove();
            timber.alignMenu();
            timber.accessibleNav();
        }, 200, 'uniqueID');
    });
    timber.alignMenu();
    timber.accessibleNav();
};

timber.alignMenu = function () {
    var $nav = timber.cache.$navigation,
        w = 0,
        i = 0;
    wrapperWidth = $nav.outerWidth() - 101,
        menuhtml = '';

    if (window.innerWidth < timber.vars.bpLarge) {
        return;
    }

    $.each($nav.children(), function () {
        var $el = $(this);

        // Ignore hidden customer links (for mobile)
        if (!$el.hasClass('large-hide')) {
            w += $el.outerWidth(true);
        }

        if (wrapperWidth < w) {
            menuhtml += $('<div>').append($el.clone()).html();
            $el.remove();

            // Ignore hidden customer links (for mobile)
            if (!$el.hasClass('large-hide')) {
                i++;
            }
        }
    });

    if (wrapperWidth < w) {
        $nav.append(
            '<li id="moreMenu" class="site-nav--has-dropdown">'
            + '<a href="#">' + "More" +'<span class="icon icon-arrow-down" aria-hidden="true"></span></a>'
            + '<ul id="moreMenu--list" class="site-nav--dropdown">' + menuhtml + '</ul></li>'
        );

        if (i <= 1) {
            // Bail, and replace original nav items
            timber.cache.$navigation.append($('#moreMenu--list').html());
            $('#moreMenu').remove();
        }
    }
};

timber.toggleMenu = function () {
    timber.cache.$menuToggle.on('click', function () {
        timber.cache.$body.toggleClass('show-nav');

        // Close ajax cart if open (keep selectors live, modal is inserted with JS)
        if ($('#ajaxifyModal').hasClass('is-visible')) {
            $('#ajaxifyModal').removeClass('is-visible');
            timber.cache.$body.addClass('show-nav');
        }
    });

    // Open sub navs on small screens
    timber.cache.$hasDropdownItem.on('click touchend', function (evt) {
        if (timber.cache.$body.hasClass('show-nav')) {
            var $el = $(this);

            if (!$el.hasClass('show-dropdown')) {
                evt.preventDefault();
                $el.addClass('show-dropdown');
            }

        }
        ;
    })
};

timber.sliders = function () {
    var $slider = timber.cache.$slider;

    if ($slider.length) {
        $(window).on('load', function () {
            $slider.flexslider({
                animation: 'slide',
                animationSpeed: 500,
                pauseOnHover: true,
                keyboard: false,
                slideshow: false,
                slideshowSpeed: 7000,
                smoothHeight: true
            });
        });
    }
};

timber.productImageSwitch = function () {
    if (timber.cache.$thumbImages.length) {
        // Switch the main image with one of the thumbnails
        // Note: this does not change the variant selected, just the image
        timber.cache.$thumbImages.on('click', function (evt) {
            evt.preventDefault();
            var newImage = $(this).attr('href');
            timber.switchImage(newImage, null, timber.cache.$productImage);
        });
    }
};

timber.switchImage = function (src, imgObject, el) {
    // Make sure element is a jquery object
    var $el = $(el);
    $el.attr('src', src);

    
    // Update new image src to grande
    var zoomSrc = src.replace('_medium.', '_1024x1024.').replace('_large.', '_1024x1024.');
    $el.attr('data-zoom', zoomSrc);

    timber.productImageZoom();
    
};

timber.productImageZoom = function () {
    

    if (!timber.cache.$productImageWrap.length) {
        return;
    }
    ;

    // Destroy zoom (in case it was already set), then set it up again
    timber.cache.$productImageWrap.trigger('zoom.destroy');

    if (timber.vars.isLargeBp) {
        timber.cache.$productImageWrap.addClass('image-zoom').zoom({
            url: timber.cache.$productImage.attr('data-zoom')
        });
    }
    
};

timber.socialSharing = function () {
    // General selectors
    var $buttons = timber.cache.$shareButtons,
        $shareLinks = $buttons.find('a'),
        permalink = $buttons.attr('data-permalink');

    // Share button selectors
    var $fbLink = $('.share-facebook'),
        $twitLink = $('.share-twitter'),
        $pinLink = $('.share-pinterest'),
        $googleLink = $('.share-google');

    if ($fbLink.length) {
        $.getJSON('https://graph.facebook.com/?id=' + permalink + '&callback=?', function (data) {
            if (data.shares) {
                $fbLink.find('.share-count').text(data.shares).addClass('is-loaded');
            } else {
                $fbLink.find('.share-count').remove();
            }
        });
    }
    ;

    if ($twitLink.length) {
        $.getJSON('https://cdn.api.twitter.com/1/urls/count.json?url=' + permalink + '&callback=?', function (data) {
            if (data.count > 0) {
                $twitLink.find('.share-count').text(data.count).addClass('is-loaded');
            } else {
                $twitLink.find('.share-count').remove();
            }
        });
    }
    ;

    if ($pinLink.length) {
        $.getJSON('https://api.pinterest.com/v1/urls/count.json?url=' + permalink + '&callback=?', function (data) {
            if (data.count > 0) {
                $pinLink.find('.share-count').text(data.count).addClass('is-loaded');
            } else {
                $pinLink.find('.share-count').remove();
            }
        });
    }
    ;

    if ($googleLink.length) {
        // Can't currently get Google+ count with JS, so just pretend it loaded
        $googleLink.find('.share-count').addClass('is-loaded');
    }

    // Share popups
    $shareLinks.on('click', function (e) {
        e.preventDefault();
        var el = $(this),
            popup = el.attr('class').replace('-', '_'),
            link = el.attr('href'),
            w = 700,
            h = 400;

        // Set popup sizes
        switch (popup) {
            case 'share-twitter':
                h = 300;
                break;
            case 'share-fancy':
                w = 480;
                h = 720;
                break;
            case 'share-google':
                w = 500;
                break;
        }

        window.open(link, popup, 'width=' + w + ', height=' + h);
    });
};

timber.equalHeights = function () {
    $(window).load(function () {
        resizeElements();
    });

    $(window).resize(function () {
        afterResize(function () {
            resizeElements();
        }, 250, 'id');
    });

    function resizeElements() {
        timber.cache.$featuredImages.css('height', 'auto').equalHeights();
        timber.cache.$featuredBoxes.css('height', 'auto').equalHeights();
        timber.cache.$productGridImages.css('height', 'auto').equalHeights();
    }
};

timber.loadData = function () {
    console.log('I am here');
}

timber.responsiveVideos = function () {
    $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
    $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

timber.toggleFilters = function () {
    if (timber.cache.$collectionFilters.length) {
        timber.cache.$toggleFilterBtn.on('click', function () {
            timber.cache.$toggleFilterBtn.toggleClass('is-active');
            timber.cache.$collectionFilters.slideToggle(200);

            // Scroll to top of filters if user is down the page a bit
            if ($(window).scrollTop() > timber.cache.$breadcrumbs.offset().top) {
                $('html, body').animate({
                    scrollTop: timber.cache.$breadcrumbs.offset().top
                });
            }
        });
    }
};

timber.formatMoney = function (val) {
    

    

    
    if(moneyFormat.indexOf('money') === -1)
    {
        if ((moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1)) {
            val = val.replace('.', '<sup>') + '</sup>';
        }
        else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
            val = val.replace(',', '<sup>') + '</sup>';
        }
    }
    

    return val;
};

timber.formatSaleTag = function (val) {
    if (moneyFormat.indexOf('money') === -1) {
        if ((moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1)) {
            return val.replace('.', '<sup>') + '</sup>';
        }
        else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
            return val.replace(',', '<sup>') + '</sup>';
        }
    }
    return val;
};

// Initialize Timber's JS on docready
$(timber.init)


//about header
$("#aboutUsBtn").click(function () {
    $("#productsHeader").hide();
    $("#newsroom-tabs").hide();
    $("#support-tabs").hide();
    $("#productsHeader").hide();
    $("#footerLinksHeader").hide();
    $("#aboutUsHeader").slideToggle();
    $("#storeHeader").hide();
});

//product Header
$("#productMenu").click(function () {
    $("#aboutUsHeader").hide();
    $("#newsroom-tabs").hide();
    $("#support-tabs").hide();
    $("#footerLinksHeader").hide();
    $("#productsHeader").slideToggle();
    $("#storeHeader").hide();
});


//newsroom
$("#newsroomMenu").click(function () {
    $("#productsHeader").hide();
    $("#aboutUsHeader").hide();
    $("#support-tabs").hide();
    $("#footerLinksHeader").hide();
    $("#newsroom-tabs").slideToggle();
    $("#storeHeader").hide();
});

//support
$("#supportMenu").click(function () {
    $("#productsHeader").hide();
    $("#aboutUsHeader").hide();
    $("#footerLinksHeader").hide();
    $("#support-tabs").slideToggle();
    $("#newsroom-tabs").hide();
    $("#storeHeader").hide();
});


//accordion
$("#hemoglobinContent").hide();
$("#hemoglobin").click(function () {
    $("#hemoglobinContent").slideToggle();
    $("#hemoglobin_plus").toggle();
    $("#hemoglobin_minus").toggle();
});

$("#pulseRateContent").hide();
$("#pulseRate").click(function () {
    $("#pulseRateContent").slideToggle();
    $("#pulseRate_plus").toggle();
    $("#pulseRate_minus").toggle();
});

$("#oxygenContent").hide();
$("#oxygenBtn").click(function () {
    $("#oxygenContent").slideToggle();
    $("#oxygenBtn_plus").toggle();
    $("#oxygenBtn_minus").toggle();
});

$("#carboxyhemoglobinContent").hide();
$("#carboxyhemoglobinBtn").click(function () {
    $("#carboxyhemoglobinContent").slideToggle();
    $("#carboxyhemoglobinBtn_plus").toggle();
    $("#carboxyhemoglobinBtn_minus").toggle();
});


$("#carbonmonoxideContent").hide();
$("#carbonmonoxideBtn").click(function () {
    $("#carbonmonoxideContent").slideToggle();
    $("#carbonmonoxideBtn_plus").toggle();
    $("#carbonmonoxideBtn_minus").toggle();
});

$("#methemoglobinContent").hide();
$("#methemoglobinBtn").click(function () {
    $("#methemoglobinContent").slideToggle();
    $("#methemoglobinBtn_plus").toggle();
    $("#methemoglobinBtn_minus").toggle();
});



$("#pulseContent").hide();
$("#pulseBtn").click(function () {
    $("#pulseContent").slideToggle();
    $("#pulseBtn_plus").toggle();
    $("#pulseBtn_minus").toggle();
});

$("#perfusionContent").hide();
$("#perfusion").click(function () {
    $("#perfusionContent").slideToggle();
    $("#perfusion_plus").toggle();
    $("#perfusion_minus").toggle();
});


$("#oxyegensatContent").hide();
$("#oxygensatBtn").click(function () {
    $("#oxyegensatContent").slideToggle();
    $("#oxygensatBtn_plus").toggle();
    $("#oxygensatBtn_minus").toggle();
});

$("#respContent").hide();
$("#respBtn").click(function () {
    $("#respContent").slideToggle();
    $("#respBtn_plus").toggle();
    $("#respBtn_minus").toggle();
});

$("#plethContent").hide();
$("#plethBtn").click(function () {
    $("#plethContent").slideToggle();
    $("#plethBtn_plus").toggle();
    $("#plethBtn_minus").toggle();

});

function on_linkClicked(el) {
    window.open($(el).attr('href'), '_blank');
}

//pagination
$("#pages li a").click(function () {
    $("#pages li a").removeClass("active");
    $(this).addClass("active");
});


$(document).ready(function () {

    var url = window.location.pathname.split("/");
    if (url[1] == "products" || url[2] == "ember-features" || url[2] == "why-ember" || url[2] == "ember-technical-papers" || url[2] == "ember" ) {
        if (url[2] == "buy-ember-sport" ||  url[2] == "buy-ember-sport-premium" || url[2] == "buy-ember-sport-oxygen-bundle" || url[2] == "buy-ember-sport-respiration-bundle" || url[2] == "dyshemoglobin-bundle" || url[2] == "coach-dashboard" || url[2] == "coach-pack" || url[2] == "factory-refurbished-ember-sport-premium" || url[2] == "agamatrix-control-solution-high" || url[2] == "agamatrix-control-solution-normal" || url[2] == "agamatrix-ultra-thin-lancets-28g-100ct" || url[2] == "agamatrix-ultra-thin-lancets-33g-100ct" || url[2] == "agamatrix-jazz-test-strips-100ct" || url[2] == "agamatrix-jazz-test-strips-50ct" || url[2] == "agamatrix-jazz-wireless-2" ) {
            $("#productsHeader").hide();
        } else {
            $("#productsHeader").show();
            $("#productMenu").addClass("tab-selected");
            $("#productsHeader #" + url[2] + "-tab").addClass("tab-selected");
        }
    }
  
  if ( url[2] == "ember"  || url[2] == "ember-features" || url[2] == "why-ember" || url[2] == "ember-technical-papers") {
      $("#productsHeader").hide();
      $("#emberHeader").show();
      $("#emberHeader").addClass("mobile-sub-header");
      $("#storeHeader").hide();
    
    $("#productMenu").click( function() {
      $("#productsHeader").show();
      $("#emberHeader").show();
      $("#storeHeader").hide();
    });
    
    $("#supportMenu").click( function() {
    $("#productsHeader").hide();
    $("#emberHeader").hide();
      $("#storeHeader").hide();
    });
    
    $("#aboutUsBtn").click( function() {
    $("#productsHeader").hide();
    $("#emberHeader").hide();
      $("#storeHeader").hide();
    });
  } else {
    $("#emberHeader").removeClass("mobile-sub-header");
  }

    if (url[2] == "about-us" || url[2] == "about-us-team" || url[2] == "press-releases" || url[2] == "history" || url[2] == "about-us-our-history" || url[2] == "press-releases" || url[2] == "careers" || url[2] == "contact-us") {
      $("#aboutUsHeader").show();
      $("#aboutUsHeader").addClass("mobile-sub-header");
      $("#aboutUsBtn").addClass("tab-selected");
      $("#aboutUsHeader #" + url[2] + "-tab").addClass("tab-selected");
    } else {
      $("#aboutUsHeader").removeClass("mobile-sub-header");
    }
  
    if (url[2] == "bonv-landing" || url[2] == 'gluscore' || url[2] == 'bonv-study-sign-up' || url[2] =="sign-up-confirmation" || url[2] == "bonv-study-signup-form" || url[2] == "feedback" ) {
        $("#bonvHeader").show();
        $("#bonvHeader").addClass("mobile-sub-header");
        $("#productMenu").addClass("tab-selected");
    } else {
      $("#bonvHeader").removeClass("mobile-sub-header");
    }
  
    if (url[2] == "bonv-landing") {
      $("#bonvDropdown").css({"display": "block", "z-index": "10000"});
    } else {
      $("#bonvDropdown").css({"display": "none"});
    }
  
    if (url[2] == "ember" || url[2]==="why-ember" || url[2]==="ember-features" || url[2]==="ember-technical-papers") {
      $("#emberDropdown").css({"display": "block", "z-index": "10000"});
    } else {
      $("#emberDropdown").css({"display": "none"});
    }
  
    if (url[2] == "ember") {
      $("#ember_landing_dropdown").css({"display": "block"});
      $("#features_dropdown").css({"display": "none"});
      $("#why_ember_dropdown").css({"display": "none"});
      $("#tech_papers_dropdown").css({"display": "none"});
    } else if (url[2]==="why-ember") {
      $("#ember_landing_dropdown").css({"display": "none"});
      $("#features_dropdown").css({"display": "none"});
      $("#why_ember_dropdown").css({"display": "block"});
      $("#tech_papers_dropdown").css({"display": "none"});      
    } else if (url[2]==="ember-features") {
      $("#ember_landing_dropdown").css({"display": "none"});
      $("#features_dropdown").css({"display": "block"});
      $("#why_ember_dropdown").css({"display": "none"});
      $("#tech_papers_dropdown").css({"display": "none"});
    } else if (url[2]==="ember-technical-papers") {
      $("#ember_landing_dropdown").css({"display": "none"});
      $("#features_dropdown").css({"display": "none"});
      $("#why_ember_dropdown").css({"display": "none"});
      $("#tech_papers_dropdown").css({"display": "block"});
    }
  
    if (url[2] == "about-us" || url[2] === "about-us-team" || url[2] === "history" || url[2] === "careers" || url[2] === "contact-us") {
      $("#aboutUsDropdown").css({"display": "block", "z-index": "10000"});
    } else {
      $("#aboutUsDropdown").css({"display": "none"});
    }
  
    if (url[2] === "about-us") {
      $("#aboutUsNavbar").css({"display": "block"});
      $("#ourTeamNavbar").css({"display": "none"});
      $("#historyNavbar").css({"display": "none"});
      $("#careersNavbar").css({"display": "none"});
      $("#contactUs_dropdown").css({"display": "none"});
    } else if (url[2] === "about-us-team") {
      $("#aboutUsNavbar").css({"display": "none"});
      $("#ourTeamNavbar").css({"display": "block"});
      $("#historyNavbar").css({"display": "none"});
      $("#careersNavbar").css({"display": "none"});
      $("#contactUs_dropdown").css({"display": "none"});
    } else if (url[2] === "history") {
      $("#aboutUsNavbar").css({"display": "none"});
      $("#ourTeamNavbar").css({"display": "none"});
      $("#historyNavbar").css({"display": "block"});
      $("#careersNavbar").css({"display": "none"});
      $("#contactUs_dropdown").css({"display": "none"});
    } else if (url[2] === "careers") {
      $("#aboutUsNavbar").css({"display": "none"});
      $("#ourTeamNavbar").css({"display": "none"});
      $("#historyNavbar").css({"display": "none"});
      $("#careersNavbar").css({"display": "block"});
      $("#contactUs_dropdown").css({"display": "none"});
    } else if (url[2] === "contact-us") {
      $("#aboutUsNavbar").css({"display": "none"});
      $("#ourTeamNavbar").css({"display": "none"});
      $("#historyNavbar").css({"display": "none"});
      $("#careersNavbar").css({"display": "none"});
      $("#contactUs_dropdown").css({"display": "block"});
    }
  
      
    if (url[2] == "support" || url[2] === "faq" || url[2] === "return-policy" || url[2] === "warranty-policy" ) {
      $("#supportDropdown").css({"display": "block", "z-index": "10000"});
    } else {
      $("#supportDropdown").css({"display": "none"});
    }
  
    if (url[2] === "support") {
      $("#support_dropdown").css({"display": "block"});
      $("#FAQ_dropdown").css({"display": "none"});
      $("#return_policy_dropdown").css({"display": "none"});
      $("#warranty_dropdown").css({"display": "none"});
    } else if (url[2] === "faq") {
      $("#support_dropdown").css({"display": "none"});
      $("#FAQ_dropdown").css({"display": "block"});
      $("#return_policy_dropdown").css({"display": "none"});
      $("#warranty_dropdown").css({"display": "none"});
    } else if (url[2] === "return-policy") {
      $("#support_dropdown").css({"display": "none"});
      $("#FAQ_dropdown").css({"display": "none"});
      $("#return_policy_dropdown").css({"display": "block"});
      $("#warranty_dropdown").css({"display": "none"});
    } else if (url[2] === "warranty-policy") {
      $("#support_dropdown").css({"display": "none"});
      $("#FAQ_dropdown").css({"display": "none"});
      $("#return_policy_dropdown").css({"display": "none"});
      $("#warranty_dropdown").css({"display": "block"});
    }
  
    if (url[2] == 'gluscore' ) {
      $("#gluscoreDropdown").css({"display": "block", "z-index": "10000"});
    } else {
      $("#gluscoreDropdown").css({"display": "none"});
    }
  
    if (url[2] == 'bonv-study-sign-up' || url[2] =="sign-up-confirmation" || url[2] == "bonv-study-signup-form" || url[2] == "feedback" ) {
      $("#joinStudyDropdown").css({"display": "block", "z-index": "10000"});
    } else {
      $("#joinStudyDropdown").css({"display": "none"});      
    }
    
    if (url[2] == "store") {
      $("#storeHeader").show();
      $("#storeHeader").addClass("mobile-sub-header");
    } else {
      $("#storeHeader").hide();
      $("#storeHeader").removeClass("mobile-sub-header");
    }

    if (url[2] == "terms-conditions" || url[2] == "regulatory" || url[2] == "legal" || url[2] == "privacy-policy" || url[2] == "patents") {
      $("#footerLinksHeader").show();
      $("#footerLinkHeader").addClass("mobile-sub-header");
      $("#productsHeader").hide();
      $("#aboutUsHeader").hide();
      $("#support-tabs").hide();
      $("#newsroom-tabs").hide();
      $("#" + url[2] + "-tab").addClass("tab-selected");
    } else {
      $("#footerLinkHeader").removeClass("mobile-sub-header");
    }

//     if (url[2] == "press-releases" || url[2] == "press-releases-PRV" || url[2] == "press-releases-CoMet" || url[2] == "press-releases-BenH" || url[2] == "in-the-news" || url[2] == "in-the-news-1") {
//         $("#newsroom-tabs").show();
//         $("#newsroomMenu").addClass("tab-selected");
//         if (url[2] == "in-the-news" || url[2] == "in-the-news-1") {
//             $("#newsroom-tabs #" + "in-the-news" + "-tab").addClass("tab-selected");
//         }

//         if (url[2] == "press-releases" || url[2] == "press-releases-PRV" || url[2] == "press-releases-CoMet" || url[2] == "press-releases-BenH") {
//             $("#newsroom-tabs #press-release-tab").addClass("tab-selected");
//         }
//     }
  
//   $(document).ready(function(){ 
//     if (url[2] === "about-us-team") {
//       $("#contactUs_dropdown").hide();
//       $("#aboutUsNavbar").show();
//        $("#ourTeamNavbar").hide();
//        $("#historyNavbar").hide();
//        $("#careersNavbar").hide();
//     }
//   }
  
    $(document).ready(function(){
      $( "#healthWellnessTab" ).click(function( event ) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: $("#storeHealthnWelness").offset().top
        }, 1000);
      });
    });
  
    $(document).ready(function(){
      $( "#fitnessTab" ).click(function( event ) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: $("#storeFitness").offset().top
        }, 1000);
      });
    });
  $(document).ready(function(){
      $( "#footerHealthWellnessTab" ).click(function( event ) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: $("#storeHealthnWelness").offset().top
        }, 5000);
      });
    });
  
    $(document).ready(function(){
      $( "#footerFitnessTab" ).click(function( event ) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: $("#storeFitness").offset().top
        }, 5000);
      });
    });


    if (url[2] == "support" || url[2] == "ember-faq" || url[2] == "faq" || url[2] == "warranty-policy" || url[2] == "return-policy") {
      $("#support-tabs").show();
      $("#support-tabs").addClass("mobile-sub-header");
      $("#supportMenu").addClass("tab-selected");
      $("#support-tabs #" + url[2] + "-tab").addClass("tab-selected");
    } else {
      $("#support-tabs").removeClass("mobile-sub-header");
    }


    if (url[1] == "collections" || url[2] == "buy-ember") {
        $("#storeMenu").addClass("tab-selected");
    }

    if (url[1] == "pages" && (url[2] == "in-the-news" || url[2] == "in-the-news-1")) {
        $("#newsroomMenu").addClass("tab-selected");
    }


    $(".header_menu #productMenu").mouseover(function () {
        $(".header_menu #productMenu svg path").css("fill", "#2d92b5");
    });

    $(".header_menu #productMenu").mouseout(function () {
        $(".header_menu #productMenu svg path").css("fill", "#425563");
    })

    $(".header_menu #aboutUsBtn").mouseover(function () {
        $(".header_menu #aboutUsBtn svg path").css("fill", "#2d92b5");
    });

    $(".header_menu #aboutUsBtn").mouseout(function () {
        $(".header_menu #aboutUsBtn svg path").css("fill", "#425563");
    });

    $(".header_menu #newsroomMenu").mouseover(function () {
        $(".header_menu #newsroomMenu svg path").css("fill", "#2d92b5");
    });

    $(".header_menu #newsroomMenu").mouseout(function () {
        $(".header_menu #newsroomMenu svg path").css("fill", "#425563");
    });

    $(".header_menu #supportMenu").mouseover(function () {
        $(".header_menu #supportMenu svg path").css("fill", "#2d92b5");
    });

    $(".header_menu #supportMenu").mouseout(function () {
        $(".header_menu #supportMenu svg path").css("fill", "#425563");
    })


    //Main Accordion Ember FAQ
    $('.emberFaqcontent').hide();

    $('.emberFaqAccord > li.active').find('.emberFaqcontent').show();

    $('.emberFaqAccord > li a').click(function () {
        $(this).toggleClass('active')
        $(this).next('.emberFaqcontent').slideToggle();
        $(this).parents('li').siblings().find('a').removeClass('active');
        $(this).parents('li').siblings().find('.emberFaqcontent').slideUp();
        return false;
    });

    //Main Accordion Ember User Guide
    $('.emberGuidecontent').hide();

    $('.emberGuideAccord > li a').click(function () {
        $(this).toggleClass('active')
        $(this).next('.emberGuidecontent').slideToggle();
        // $(this).parents('li').siblings().find('a').removeClass('active');
        // $(this).parents('li').siblings().find('.emberGuidecontent').slideUp();
        return false;
    });

    //Sub Accordion Ember FAQ
    $('.emberFaqSubAcccontent').hide();

    $('.emberFaqSubAcc > li.active').find('.emberFaqSubAcccontent').show();

    $('.emberFaqSubAcc > li a').click(function () {
//         $(this).addClass('active')
        $(this).next('.emberFaqSubAcccontent').slideToggle();
        $(this).parents('li').siblings().find('a').removeClass('active');
        $(this).parents('li').siblings().find('.emberFaqSubAcccontent').slideUp();
        return false;
    });

    $('#mobile-header .btn-click').on('click', function () {
        $('#mobile-header').toggleClass('full-mobile-header');
        $('body').toggleClass('body-css');
        $('.mobile-menu').toggleClass('inner-mobile-submenu');
        $(this).toggleClass('change');
        $('#mobile-header .mobile-wrapper').toggleClass('show-menu');
    });
    /* Navigation menu mobile view */
    $('li').on('click', function (e) {
        var menuItem = $(e.target).closest('.show-submenu');
        if (menuItem.get(0)) {
            if (menuItem.children().hasClass('show-menu')) {
                menuItem.children().toggleClass('show-menu');
                toggleCaret(menuItem);
            } else {
                $('.show-submenu').children().removeClass('show-menu');
                menuItem.children().toggleClass('show-menu');
                toggleCaret(menuItem);

            }
        }
    });

    $("#myBtn").click(function (e) {
        e.preventDefault();
        var code = $(".captcha-base__input").val();
        if(generatedCode == code) {
            const element = document.querySelector("#captchMessage");
            if(element.classList.contains("showTab")) {
                element.classList.add("hideTab");
                element.classList.remove("showTab");
            }
            $("#contact_form")[0].submit();
        } else {
            const element = document.querySelector("#captchMessage");
            if(element.classList.contains("hideTab")) {
                element.classList.add("showTab");
                element.classList.remove("hideTab");
            }
        }
    });
});

function toggleCaret(menuItem) {
    var caret = menuItem.children('.fa');
    $('.show-submenu').removeClass('blue-colr');
    if (caret.hasClass('fa-caret-down')) {
        $('.fa-caret-up').removeClass('fa-caret-up').addClass('fa-caret-down');
        caret.removeClass('fa-caret-down').addClass('fa-caret-up');
        menuItem.addClass('blue-colr'); //black
    }
    else {
        caret.removeClass('fa-caret-up').addClass('fa-caret-down');
        menuItem.removeClass('blue-colr'); //black
    }
}
/*
document.getElementById('contact_form').addEventListener('submit', function(event) {
    event.preventDefault();
    var submissionCount = 0;
    var code = $(".captcha-base__input").val();
    if ($("#duplicateContactFormEmail").val().length > 0) {
        //Skip submission
    } else {
        if(generatedCode == code){
            $("#contact_form")[0].submit();
        }
    }
});
/*


// Get the modal
var modal = document.getElementById('myModal');

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("form-modal-close")[0];

// When the user clicks the button, open the modal
btn.onclick = function() {
    modal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
    modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}
*/

$(document).ready(function(){
    // your code...
    $('#wufooFormzqd416213omt9i').contents().find('head').append('<style type=\'text/css\'>  .my-class{display:none;}  </style>');
});
